import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { duplicateDossierReportRecords } from './report.action';

@Injectable({ providedIn: 'root' })
export class DuplicateDossierReportTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                club_name: null,
                member_number: '',
                member_name: '',
                season_name: '',
                workflow_id: null,
                description: '',
                outstanding_with_fee: '',
                team: '',
                created_at: ''
            }

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'season_name';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubs = [];
    categories = [];
    has_workflow = [
        {"id": "1", "name": "COMMON.yes"},
        {"id": "0", "name": "COMMON.no"}
    ];
   

    columns = [
                { prop: 'id', name: 'REPORTS.dossier-id', sortable: false, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'club_name', name: 'REPORTS.club', sortable: false, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name", widthSet: 180},
                { prop: 'member_number', name: 'REPORTS.member-number', sortable: false, hasFilter: true, filter: "input", widthSet: 125},
                { prop: 'member_name', name: 'REPORTS.member', sortable: false, hasFilter: true, filter: "input"},
                { prop: 'season_name', name: 'REPORTS.season', sortable: false, hasFilter: true, filter: "input"},
                { prop: 'workflow_id', name: 'REPORTS.active-workflow', sortable: false, hasFilter: false, filter: "select", options: 'has_workflow', options_id: "id", options_label: "name" , widthSet: 120},
                { prop: 'description', name: 'REPORTS.description', sortable: false, hasFilter: true, filter: "input"},
                { prop: 'outstanding_with_fee', name: 'REPORTS.outstanding', sortable: false, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'team', name: 'REPORTS.team', sortable: false, hasFilter: true, filter: "input"},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: false, hasFilter: true, filter: "date", widthSet: 155}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(duplicateDossierReportRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
                id: '',
                club_name: null,
                member_number: '',
                member_name: '',
                season_name: '',
                workflow_id: null,
                description: '',
                outstanding_with_fee: '',
                team: '',
                created_at: ''
            }
        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}